import styled from 'styled-components';

export const RootContainer = styled.div`
  margin-top: calc(var(--height-header) * -1);
`;
